import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const EmptyState = ({ type = 'ongoing', userRole = 'boss' }) => {
  const navigate = useNavigate();

  const getEmptyStateContent = () => {
    if (type === 'filtered') {
      return {
        icon: '🔍',
        title: 'No projects match your filters',
        description: 'Try adjusting your search criteria or filters to find what you\'re looking for.',
        action: null
      };
    }

    if (type === 'completed') {
      return {
        icon: '✅',
        title: 'No completed projects yet',
        description: 'Projects that are marked as completed will appear here.',
        action: null
      };
    }

    if (type === 'drafts') {
      return {
        icon: '🤖',
        title: 'No draft projects',
        description: 'AI-created projects pending your review will appear here. Approve, edit, or reject them before they become active projects.',
        action: null
      };
    }

    // Default: ongoing projects empty state
    if (userRole === 'boss') {
      return {
        icon: '🏗️',
        title: 'No ongoing projects',
        description: 'Get started by creating your first renovation project. Track progress, manage teams, and stay on top of every phase.',
        action: {
          label: 'Create New Project',
          onClick: () => navigate('/project-creation')
        }
      };
    }

    return {
      icon: '📋',
      title: 'No assigned projects',
      description: 'You haven\'t been assigned to any projects yet. Check back later or contact your project manager.',
      action: null
    };
  };

  const content = getEmptyStateContent();

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] text-center px-4">
      <div className="text-6xl mb-4">{content?.icon}</div>
      <h3 className="text-2xl font-bold text-gray-900 mb-2">{content?.title}</h3>
      <p className="text-gray-600 max-w-md mb-6">{content?.description}</p>
      {content?.action && (
        <Button
          onClick={content?.action?.onClick}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
        >
          {content?.action?.label}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;